module.exports = __webpack_public_path__ + "img/google.440d4bff.png";